// react
import * as React from 'react';

// material-ui
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import Button from '@material-ui/core/Button/Button';
import withTheme from '@material-ui/core/styles/withTheme';

// project files
import * as styles from './CreditReport.css';
import CalendlyFrame from '../CalendlyFrame/CalendlyFrame';
import Title from '../shared/Title/Title';
import Layout from '../Layout/Layout';

const CreditReport = () => {
  const handleButtonClick = () => {
    const url: string = 'https://tryascend.com/qualify/soft-credit-check';

    window.open(url, '_blank');
  };

  return (
    <Layout>
      <Title text="Credit Report" center />
      <Grid container justify="center" alignItems="center" direction="column">
        <div className={styles.steps}>
          <Typography variant="headline">
            1) First, please fill out this form that provides authorization to review your credit
            report together.
          </Typography>
        </div>
        <div className={styles.button}>
          <a onClick={handleButtonClick}>
            <Button size="large" variant="contained" color="primary">
              Authorization Form
            </Button>
          </a>
        </div>
      </Grid>
      <Grid container justify="center">
        <Typography variant="headline">
          2) Please schedule a call with your analyst below to go through it together.
        </Typography>
        <CalendlyFrame />
      </Grid>
    </Layout>
  );
};

export default withTheme()(CreditReport);
